import React from 'react';
import PropTypes from 'prop-types';
import {
  printInHourDisplayFormat,
  printInShortFormatOrAsRelativeDate
} from '../../libs/dateTimePrinting';
import FormatSettingsContext from '../../components/FormatSettingsContext';
import NavigationHistory from '../../libs/NavigationHistory';
import Button from '../../components/Button/Button';
import { serializeYesplanAPIDate } from '../../libs/dateTimeUtilities';
import { Body, Meta } from '../../styled components/Typography';
import UICard from '../../styled components/UICard';
import YPTimesheetObject from '../../yesplan_classes/YPTimesheetObject';
import TimesheetStatus from '../TimesheetStatus/TimesheetStatus';
import { capture, PH_TIMESHEET_DAY_CLICKED } from '../../libs/posthogAnalytics';

class TimesheetWeekDay extends React.Component {
  constructor(props) {
    super(props);
    this.handleTimesheetDayClick = this.handleTimesheetDayClick.bind(this);
  }

  handleTimesheetDayClick() {
    const { linkUrlFor, dayDateObject, navigationHistory } = this.props;
    capture(PH_TIMESHEET_DAY_CLICKED, {
      date: serializeYesplanAPIDate(dayDateObject)
    });
    navigationHistory.goTo({
      pathname: linkUrlFor(`/timesheet/${serializeYesplanAPIDate(dayDateObject)}`),
      state: { headerTitle: printInShortFormatOrAsRelativeDate(dayDateObject) }
    });
  }

  renderAdditionalInfo() {
    const { timesheetObject } = this.props;
    if (!timesheetObject.hasSchedules()) {
      if (timesheetObject.hasUnavailabilities()) return this.renderUnavailability();
      return this.renderNoBookings();
    }
    return null;
  }

  renderNoBookings() {
    return <Meta $color="gray light">{i18n('Nothing planned')}</Meta>;
  }

  renderUnavailability() {
    const { timesheetObject } = this.props;
    const unavailabilities = timesheetObject.getUnavailabilities();

    return (
      <Meta tw="shrink truncate max-w-full space-x-4" $color="gray light">
        {unavailabilities.map((uObj) => (
          <span key={uObj.getId()}>
            {uObj.getTitle()} {printInHourDisplayFormat(uObj.getPlannedStart())}
            {'–'}
            {printInHourDisplayFormat(uObj.getPlannedEnd())}
          </span>
        ))}
      </Meta>
    );
  }

  renderChangedSinceApproval() {
    const { timesheetObject } = this.props;
    if (timesheetObject.hasEntriesWithWarningsForChangesInFinalState()) {
      return (
        <div tw="text-right mr-28 leading-16 -mt-4">
          <Meta tw="text-red-base">{i18n('Changed since approval.')}</Meta>
        </div>
      );
    }
    return null;
  }

  render() {
    const { timesheetObject } = this.props;
    const { dateFormatSetting } = this.context;

    return (
      <UICard
        tw="py-8 pl-12 pr-8"
        onClick={() => {
          this.handleTimesheetDayClick();
        }}
        data-test-timesheetweekday={serializeYesplanAPIDate(timesheetObject.date)}
      >
        <div tw="flex items-center gap-x-8">
          <div tw="mr-auto min-w-0 flex items-baseline gap-x-8">
            <Body tw="shrink-0">
              {timesheetObject.printTimesheetDay(dateFormatSetting, true)}
            </Body>
            {this.renderAdditionalInfo()}
          </div>
          <div tw="shrink-0 flex items-center ">
            <div tw="">
              {timesheetObject.hasSchedules() && (
                <TimesheetStatus tw="justify-end" status={timesheetObject.getStatus()} />
              )}
            </div>

            <Button contentType="icon" icon="navigate-next" size="small" />
          </div>
        </div>
        {this.renderChangedSinceApproval()}
      </UICard>
    );
  }
}

TimesheetWeekDay.propTypes = {
  linkUrlFor: PropTypes.func.isRequired,
  timesheetObject: PropTypes.instanceOf(YPTimesheetObject).isRequired,
  navigationHistory: PropTypes.instanceOf(NavigationHistory).isRequired,
  contextAsProp: PropTypes.shape({
    dateFormatSetting: PropTypes.string,
    timeFormatSetting: PropTypes.string
  }).isRequired,
  dayDateObject: PropTypes.shape({ isSame: PropTypes.func.isRequired }).isRequired
};

TimesheetWeekDay.contextType = FormatSettingsContext;

TimesheetWeekDay.defaultProps = {};

export const TimesheetWeekDayWithContext = (Component) => (props) => {
  return (
    <FormatSettingsContext.Consumer>
      {(value) => <Component {...props} contextAsProp={value} />}
    </FormatSettingsContext.Consumer>
  );
};

export default TimesheetWeekDayWithContext(TimesheetWeekDay);
